var render, staticRenderFns
import script from "./ConfigureSignApiStamp.vue?vue&type=script&lang=js&"
export * from "./ConfigureSignApiStamp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d6ab3a4')) {
      api.createRecord('6d6ab3a4', component.options)
    } else {
      api.reload('6d6ab3a4', component.options)
    }
    
  }
}
component.options.__file = "src/febos/global/usuario/components/sign/advanced/aSignApi/components/ConfigureSignApiStamp.vue"
export default component.exports